<template>
  <div>
    <div class="table_content">
      <!-- 表格内容 -->
      <commonTitle></commonTitle>

      <div class="search">
        <el-form ref="form" :model="form" label-width="80px" :inline="true">
          <el-form-item label="小区名称:">
            <el-input v-model="form.villageName" size="mini" placeholder="请输入小区名称"></el-input>
          </el-form-item>
         
            <button @click.prevent="common()" style="cursor: pointer;">搜索</button>
            <button @click.prevent="exportExcel()" style="cursor: pointer;">导出</button>
         
        </el-form>
      </div>
      <!--表格-->
      <template>
        <el-card>
          <el-table
            ref="multipleTable"
            :data="tableData"
            tooltip-effect="dark"
            style="width: 100%"
            stripe
            v-loading="loading"
            element-loading-text="拼命加载中"
            @selection-change="handleSelectionChange"
          >
            <el-table-column label="小区名称" show-overflow-tooltip>
              <template slot-scope="scope">
                <el-link
                  type="primary"
                  :underline="false"
                  @click="handleSelect(scope.$index, scope.row)"
                >{{scope.row.villageName}}</el-link>
              </template>
            </el-table-column>
            <el-table-column property="assessmentSum" label="应缴金额" show-overflow-tooltip></el-table-column>
            <el-table-column property="amountPaySum" label="已缴金额" show-overflow-tooltip></el-table-column>
            <el-table-column property="standardAmountSum" label="标准金额" show-overflow-tooltip></el-table-column>
            <el-table-column property="houseacctBalSum" label="账户余额" show-overflow-tooltip></el-table-column>
          </el-table>
          <el-pagination
            background
            style="margin-top: 50px"
            layout="prev, pager, next"
            :page-size="15"
            @current-change="handleCurrentChange"
            :total="totalNum"
          ></el-pagination>
        </el-card>
      </template>
    </div>
  </div>
</template>

<script>
import qs from "qs";
import commonTitle from "../table/commonTitle";
export default {
  name: "villagePlan",
  data() {
    return {
      url: this.$Config.base_server,
      form: {
        villageName: ""
      },
      tableData: [],
      multipleSelection: [],
      totalNum: 15,
      loading: false,
      data: {
        //查询条件
        access_token: localStorage.getItem("token"),
        limit: 15
      }
    };
  },
  components: {
    commonTitle
  },
  mounted() {
    this.common();
  },
  methods: {
    common(currentPage = 0) {
      const that = this;
      that.loading = true;

      that.data.page = currentPage;
      //搜索框的值
      that.data.villageName = that.form.villageName;
      // that.data.actResult = that.form.region;
      $.ajax({
        url: this.url + "/api-public/report/capitalSum",
        data: that.data,
        contentType: "application/json",
        type: "get",
        success: function(res) {
          that.loading = false;
          if (res.code == 0) {
            that.totalNum = res.count;
            that.tableData = res.data;
          }
        },
        error: function(res) {
          that.loading = false;
        }
      });
    },
    toggleSelection(rows) {
      if (rows) {
        rows.forEach(row => {
          this.$refs.multipleTable.toggleRowSelection(row);
        });
      } else {
        this.$refs.multipleTable.clearSelection();
      }
    },
    handleCurrentChange(val) {
      //当前页数改变
      this.common(val);
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    handleSelect(index, row) {
      //查看楼幢
      //存储小区数据
      localStorage.setItem("villageData", JSON.stringify(row));
      this.$router.push({ name: "reportTower" });
    },
    exportExcel() {
      var villageNameVal = this.form.villageName;
      var url =
        this.url +
        "/api-public/report/capitalSum/export?access_token=" +
        localStorage.getItem("token") +
        "&villageName=" +
        villageNameVal;
      location.href = url;
    }
  }
};
</script>

<style scoped lang="scss">
@import "../../assets/css/table/first_table.css";

.el-button {
  padding: 5px 5px;
}
</style>
